const priceFormatter = new Intl.NumberFormat('da-DK', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const krFormatter = new Intl.NumberFormat('da-DK', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** "1,06 kr/kWh" */
export function formatPricePerKwh(value: number): string {
  return `${priceFormatter.format(value)} kr/kWh`
}

/** "12,34 kr" */
export function formatKr(value: number): string {
  return `${krFormatter.format(value)} kr`
}

/** "01:00" */
export function formatHour(hour: number): string {
  return `${String(hour).padStart(2, '0')}:00`
}

/** "01:00, 02:00, 03:00" — already-sorted hours */
export function formatHourList(hours: readonly number[]): string {
  return hours.map(formatHour).join(', ')
}

/** Capitalised Danish weekday + date, e.g. "Tirsdag 14. april" */
export function formatDanishDate(date: Date): string {
  const formatter = new Intl.DateTimeFormat('da-DK', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'Europe/Copenhagen',
  })
  const formatted = formatter.format(date)
  return formatted.charAt(0).toUpperCase() + formatted.slice(1)
}
